import { MAIN_EDITOR_TOOLTIPS } from 'constants/editorTooltips';
import { CROP_PANEL_TOOLTIPS } from 'constants/cropTooltips';
import { STICKERS_PANEL_TOOLTIPS } from 'constants/stickersTooltips';
import { TEXT_PANEL_TOOLTIPS } from 'constants/textPanelTooltips';
import { markTooltipSeen, hasSeenTooltip } from './tooltipCookies';

export const EDITOR_TOOLTIPS_CHANGED_EVENT = 'editor-tooltips-changed';

export const ALL_EDITOR_TOOLTIPS = [
  ...MAIN_EDITOR_TOOLTIPS,
  ...CROP_PANEL_TOOLTIPS,
  ...STICKERS_PANEL_TOOLTIPS,
  ...TEXT_PANEL_TOOLTIPS,
];

export function notifyEditorTooltipsChanged() {
  window.dispatchEvent(new Event(EDITOR_TOOLTIPS_CHANGED_EVENT));
}

export function markAllEditorTooltipsSeen() {
  ALL_EDITOR_TOOLTIPS.forEach((tooltip) => {
    markTooltipSeen(tooltip.cookieKey, 365);
  });
}

export function resetAllEditorTooltips() {
  ALL_EDITOR_TOOLTIPS.forEach((tooltip) => {
    document.cookie = `${tooltip.cookieKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
}

export function hasCompletedEditorTooltips() {
  return ALL_EDITOR_TOOLTIPS.every((tooltip) =>
    hasSeenTooltip(tooltip.cookieKey),
  );
}
